<template>
  <div id="app" >
    <div class="main" >

        
     </div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
    data() {
          return {
            docmHeight: document.documentElement.clientHeight, //默认屏幕高度
            showHeight: document.documentElement.clientHeight, //实时屏幕高度
            hidshow:true, //显示或者隐藏footer,
            isResize:false,//默认屏幕高度是否已获取
            background:''
          };
    },
    mounted() {
          window.onresize = ()=>{
            return(()=>{
            if (!this.isResize) {
            //默认屏幕高度
            this.docmHeight = document.documentElement.clientHeight;
            this.isResize = true;
            }
            //实时屏幕高度
            this.showHeight = document.body.clientHeight;
            // console.log(this.showHeight);
            })()
            this.background
      }
    },
      watch: {
          showHeight() {
              if(this.docmHeight >= this.showHeight){
              this.hidshow = false
              }else{
              this.hidshow = true
              }
              // console.log(this.hidshow);
              }
            }
      }
</script>

<style>
  #app{
    
     width: 100%;
     height: 100%;
     position: relative;
     background: #f5f5f5;
    
     
   }
   @media screen and (device-width:375px) and (device-height:812px){
          .footer {
            margin-bottom:34px;
          }
      }
      /* 适配iphoneXR iphoneXSMax */
    @media screen and (device-width:414px) and (device-height:896px){
          .footer {
            margin-bottom:34px;
          }
    }

</style>



// WEBPACK FOOTER //
// src/App.vue